import { useSelector } from 'react-redux'
import useCheckAccessRights from './useCheckAccessRights'

/**
 * returns the current moduleContext from redux and the users access right for that module
 * @returns { module:Array, { read: boolean, write: boolean, create: boolean, delete: boolean }}
 */
const useCurrentModuleContext = () => {
  const { current } = useSelector(state => state.moduleContext)
  const rightsGroup = current?.module
  const read = useCheckAccessRights(rightsGroup?.READ)
  const write = useCheckAccessRights(rightsGroup?.WRITE)
  const create = useCheckAccessRights(rightsGroup?.CREATE)
  const del = useCheckAccessRights(rightsGroup?.DELETE)
  return { ...current, rights: { read, write, create, delete: del } }
}

export default useCurrentModuleContext
